import { render, staticRenderFns } from "./CadastrarCompra.vue?vue&type=template&id=89e9269a&scoped=true&"
import script from "./CadastrarCompra.vue?vue&type=script&lang=js&"
export * from "./CadastrarCompra.vue?vue&type=script&lang=js&"
import style0 from "./CadastrarCompra.vue?vue&type=style&index=0&id=89e9269a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89e9269a",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCol,VContainer,VRow,VSelect})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Trabalho\\Lupa Soluções em TI\\Clientes\\Leonardo Raton\\Site\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('89e9269a')) {
      api.createRecord('89e9269a', component.options)
    } else {
      api.reload('89e9269a', component.options)
    }
    module.hot.accept("./CadastrarCompra.vue?vue&type=template&id=89e9269a&scoped=true&", function () {
      api.rerender('89e9269a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/Modal/components/CadastrarCompra.vue"
export default component.exports